import EmojiPickerInput from "@/components/content-modal-comps/emoji-picker-input";
import { useTheme } from "next-themes";

const PostCmtInpEmojiBox = ({ handleOutsideClick, handleEmojiClick }) => {
  const { theme } = useTheme();
  return (
    <div className="absolute left-0 bottom-10 z-30 border dark:border-light_primary_label rounded-xl bg-white overflow-y-auto">
      <EmojiPickerInput
        onEmojiSelect={(emoji) => handleEmojiClick(emoji?.native)}
        onClickOutside={handleOutsideClick}
        previewPosition={"none"}
        theme={theme}
      />
    </div>
  );
};

export default PostCmtInpEmojiBox;
